import { AlgoliaSearchBox } from '@alltrails/modules/AlgoliaSearch';
import '@alltrails/modules/AlgoliaSearch/index.css';

const createReactClass = require('create-react-class');

const LocationInfoHolder = createReactClass({
  getInitialState() {
    // filter on load for the case of loading in with initial location object
    let { states } = this.props;
    if (this.props.locationObject) {
      states = states.filter(
        function (state) {
          return state.country_id === this.props.locationObject.country || state.country === this.props.locationObject.country;
        }.bind(this)
      );
    }
    return {
      states,
      saveOrDeleteStatus: null
    };
  },
  componentDidMount() {
    this.didSwitchParentObject = false;
  },
  componentWillReceiveProps(newProps) {
    if (newProps.locationObject) {
      this.handleCountryChange(newProps.locationObject.country);
    }
    this.setState({ saveOrDeleteStatus: null });
  },
  componentDidUpdate() {
    // workarounds for React state squashing default values for text fields
    if (this.props.locationObject && (this.didSwitchParentObject || this.props.locationObject.name !== this.refs.name.value)) {
      if (this.refs.name !== undefined) {
        this.refs.name.value = this.props.locationObject.name;
      }
      if (this.props.locationObject.location) {
        this.refs.lat.value = this.props.locationObject.location.latitude;
        this.refs.lng.value = this.props.locationObject.location.longitude;
      } else {
        this.refs.lat.value = this.props.locationObject.latitude;
        this.refs.lng.value = this.props.locationObject.longitude;
      }
      this.didSwitchParentObject = false;
    }
    // set up PDF uploader if new selected object is a park
  },
  createInfoDiv(obj) {
    const showAddParkForm = obj && obj.obj_type === 'parks' && !obj.id;
    const name = Array.isArray(obj.name) ? obj.name[0] : obj.name;
    const title = showAddParkForm ? 'Add New Park' : name;
    const countriesOptions = [];
    this.props.countries.forEach(function (item) {
      return <option>item.name</option>;
    });

    let nameEditDiv = null;
    if (obj.obj_type == 'countries') {
      nameEditDiv = <div className="edit-field display-only">Name: {name}</div>;
    } else {
      nameEditDiv = (
        <div className="edit-field">
          Name: <input className="edit-value" defaultValue={name} ref="name" />
        </div>
      );
    }

    let countriesSelect = null;
    let statesSelect = null;
    let cityDisplayDiv = null;
    if (!showAddParkForm) {
      if (obj.obj_type == 'cities' || obj.obj_type == 'parks') {
        const thisCountry = this.props.countries.filter(function (item, keyz) {
          if (item.id === obj.country) {
            return true;
          }
        });
        countriesSelect = <div className="edit-field">Country: {thisCountry[0].name}</div>;
      } else if (obj.country || obj.country_id) {
        countriesSelect = (
          <div className="edit-field">
            Country:
            <select onChange={this.handleCountrySelectChange} ref="country">
              {this.props.countries.map(function (item, keyz) {
                if (item.id === obj.country || item.id === obj.country_id) {
                  return (
                    <option value={item.id} selected="selected">
                      {item.name}
                    </option>
                  );
                }
                return <option value={item.id}>{item.name}</option>;
              })}
            </select>
          </div>
        );
      }
      if (obj.obj_type == 'parks' || obj.obj_type == 'cities') {
        const statesOptions = this.state.states.map(function (state, keyz) {
          if (state.id === obj.state) {
            return (
              <option value={state.id} selected="selected">
                {state.name}
              </option>
            );
          }
          return <option value={state.id}>{state.name}</option>;
        });
        if (!obj.state) {
          statesOptions.unshift(
            <option value="" selected="selected">
              {' '}
              -{' '}
            </option>
          );
        } else {
          statesOptions.unshift(<option value=""> - </option>);
        }
        statesSelect = (
          <div className="edit-field">
            State:
            <select ref="state">{statesOptions}</select>
          </div>
        );
      }
      if (obj.obj_type == 'parks' && (obj.type == null || obj.type == 'C')) {
        cityDisplayDiv = <div className="edit-field">City: {obj.city}</div>;
      }
    }

    let parkTypeSelect = null;
    if (obj.obj_type == 'parks') {
      parkTypeSelect = (
        <div className="edit-field">
          Park Type:
          <select ref="park_type">
            {[
              <option value={null} selected={obj.type == null ? 'selected' : null}>
                {' '}
                -{' '}
              </option>,
              <option value="B" selected={obj.type == 'B' ? 'selected' : null}>
                Bureau of Land Management
              </option>,
              <option value="O" selected={obj.type == 'O' ? 'selected' : null}>
                County Park
              </option>,
              <option value="C" selected={obj.type == 'C' ? 'selected' : null}>
                Local Park
              </option>,
              <option value="F" selected={obj.type == 'F' ? 'selected' : null}>
                National Forest
              </option>,
              <option value="H" selected={obj.type == 'H' ? 'selected' : null}>
                National Historical Park
              </option>,
              <option value="I" selected={obj.type == 'I' ? 'selected' : null}>
                National Historical Site
              </option>,
              <option value="M" selected={obj.type == 'M' ? 'selected' : null}>
                National Monument
              </option>,
              <option value="N" selected={obj.type == 'N' ? 'selected' : null}>
                National Park
              </option>,
              <option value="P" selected={obj.type == 'P' ? 'selected' : null}>
                National Preserve
              </option>,
              <option value="A" selected={obj.type == 'A' ? 'selected' : null}>
                National Recreational Area
              </option>,
              <option value="E" selected={obj.type == 'E' ? 'selected' : null}>
                National Seashore
              </option>,
              <option value="W" selected={obj.type == 'W' ? 'selected' : null}>
                National Wilderness
              </option>,
              <option value="R" selected={obj.type == 'R' ? 'selected' : null}>
                Regional Park
              </option>,
              <option value="T" selected={obj.type == 'T' ? 'selected' : null}>
                State Forest
              </option>,
              <option value="V" selected={obj.type == 'V' ? 'selected' : null}>
                State Nature Reserve
              </option>,
              <option value="S" selected={obj.type == 'S' ? 'selected' : null}>
                State Park
              </option>
            ]}
          </select>
        </div>
      );
    }

    let latitudeDiv = null;
    let longitudeDiv = null;
    if (obj.location) {
      latitudeDiv = (
        <div className="edit-field">
          Latitude: <input className="edit-value" defaultValue={obj.location.latitude} ref="lat" />
        </div>
      );
      longitudeDiv = (
        <div className="edit-field">
          Longitude: <input className="edit-value" defaultValue={obj.location.longitude} ref="lng" />
        </div>
      );
    } else {
      latitudeDiv = (
        <div className="edit-field">
          Latitude: <input className="edit-value" defaultValue={obj.latitude} ref="lat" />
        </div>
      );
      longitudeDiv = (
        <div className="edit-field">
          Longitude: <input className="edit-value" defaultValue={obj.longitude} ref="lng" />
        </div>
      );
    }

    let category = '';
    if (obj.obj_type === 'parks') {
      category = 'Park';
    } else if (obj.obj_type === 'cities') {
      category = 'City';
    } else if (obj.obj_type === 'states') {
      category = 'State';
    } else {
      category = 'Country';
    }
    let locationLinkDiv = null;
    if (obj.url) {
      var url = `/${obj.url}`;
      locationLinkDiv = (
        <div className="edit-field display-only">
          <a href={url} target="_blank">
            {category} Page
          </a>
        </div>
      );
    } else if (obj.slug) {
      var url = `/${obj.slug}`;
      if (obj.obj_type === 'parks') {
        url = `/parks${url}`;
      }
      locationLinkDiv = (
        <div className="edit-field display-only">
          <a href={url} target="_blank">
            {category} Page
          </a>
        </div>
      );
    }

    return (
      <div>
        <h3>{title}</h3>
        <div className="compare-container-location">
          {locationLinkDiv}
          {nameEditDiv}
          {latitudeDiv}
          {longitudeDiv}
          {parkTypeSelect}
          {cityDisplayDiv}
          {statesSelect}
          {countriesSelect}
          {!showAddParkForm && (
            <div className="edit-field display-only">
              <span>Popularity:</span>
              <span className="edit-value">{obj.popularity}</span>
            </div>
          )}
          {!showAddParkForm && (
            <div className="edit-field display-only">
              <span>Trails:</span>
              <span className="edit-value">{obj.trails_count}</span>
            </div>
          )}
          {obj.reviews_count && (
            <div className="edit-field display-only">
              <span>Reviews:</span>
              <span className="edit-value">{obj.reviews_count}</span>
            </div>
          )}
          {obj.photos_count && (
            <div className="edit-field display-only">
              <span>Photos:</span>
              <span className="edit-value">{obj.photos_count}</span>
            </div>
          )}
          {obj.tracks_count && (
            <div className="edit-field display-only">
              <span>Activities:</span>
              <span className="edit-value">{obj.tracks_count}</span>
            </div>
          )}
        </div>
      </div>
    );
  },
  handleSelect(object) {
    this.props.handleObjectSelected(object, this.props.index);
    this.didSwitchParentObject = true;
  },
  handleCountrySelectChange(event) {
    this.handleCountryChange(parseInt(event.target.value));
  },
  handleCountryChange(newCountryId) {
    const statesByCountry = [];
    if (newCountryId) {
      this.props.states.forEach(function (item) {
        if (item.country_id === newCountryId || item.country === newCountryId) {
          statesByCountry.push(item);
        }
      });
    }
    this.setState({ states: statesByCountry });
  },
  handleDeletePark() {
    if (confirm(`Are you sure you want to delete ${this.props.locationObject.name}?  This cannot be undone.`)) {
      this.setState({ saveOrDeleteStatus: 'Deletion in progress' });

      this.props.performDelete(
        this.props.locationObject,
        {},
        function (success) {
          if (success) {
            this.setState({ saveOrDeleteStatus: 'Deletion complete' });
          } else {
            this.setState({ saveOrDeleteStatus: 'An error occurred' });
          }
        }.bind(this)
      );
    }
  },
  handleSave() {
    this.setState({ saveOrDeleteStatus: 'Saving in progress' });
    // make a deep copy of the location object to display changed attributes and stop React from rendering presave attrs
    const modifiedLocationObject = JSON.parse(JSON.stringify(this.props.locationObject));
    if (modifiedLocationObject.location) {
      modifiedLocationObject.location.latitude = parseFloat(this.refs.lat.value);
      modifiedLocationObject.location.longitude = parseFloat(this.refs.lng.value);
    } else {
      modifiedLocationObject.latitude = parseFloat(this.refs.lat.value);
      modifiedLocationObject.longitude = parseFloat(this.refs.lng.value);
    }

    const params = {
      latitude: this.refs.lat.value,
      longitude: this.refs.lng.value
    };
    if (this.refs.name !== undefined) {
      params.name = this.refs.name.value;
      modifiedLocationObject.name = this.refs.name.value;
    }
    if (this.refs.state !== undefined && this.refs.state.value !== null) {
      params.state_id = this.refs.state.value;
      modifiedLocationObject.state = parseInt(this.refs.state.value);
    }
    if (this.refs.country !== undefined) {
      params.country_id = this.refs.country.value;
      modifiedLocationObject.country = parseInt(this.refs.country.value);
    }
    if (this.refs.park_type !== undefined && this.refs.park_type.value !== '' && this.refs.park_type.value !== null) {
      params.type = this.refs.park_type.value;
      modifiedLocationObject.type = this.refs.park_type.value;
    }

    this.props.performSave(
      this.props.locationObject,
      modifiedLocationObject,
      params,
      this.props.index,
      function (success, data) {
        if (success) {
          if (!this.props.locationObject.id && data) {
            this.setState({ saveOrDeleteStatus: `Added with id ${data.id} and slug ${data.slug}` }, () => {
              if (this.props.locationObject.obj_type === 'parks') {
                window.location = `/merge-locations?area_id=${data.id}`;
              }
            });
          } else {
            this.setState({ saveOrDeleteStatus: 'Change queued for processing' });
          }
        } else {
          this.setState({ saveOrDeleteStatus: 'An error occurred' });
        }
      }.bind(this)
    );
  },
  render() {
    let objectInfoBlock = null;
    let deleteButton = null;
    let saveButton = null;
    if (this.props.locationObject || this.props.showAddForm) {
      objectInfoBlock = this.createInfoDiv(this.props.locationObject);
      saveButton = (
        <div className="user-info-centered">
          <div className="btn green rounded simple" onClick={this.handleSave}>
            Save
          </div>
        </div>
      );
      if (this.props.locationObject && this.props.locationObject.obj_type === 'parks' && this.props.locationObject.id) {
        deleteButton = (
          <div className="user-info-centered">
            <div className="btn orange rounded simple" onClick={this.handleDeletePark}>
              Delete
            </div>
          </div>
        );
      }
    }
    let statusText = null;
    if (this.state.saveOrDeleteStatus) {
      statusText = <div className="user-info-centered">{this.state.saveOrDeleteStatus}</div>;
    }
    const floatClass = this.props.left ? 'floatleft edit-container' : 'floatright edit-container';
    let labelText = '';
    let searchBoxPlaceholderText = 'Enter a city, state or park name...';
    if (this.props.allowedTypes.length === 2) {
      labelText = 'Enter City, State or Park';
    } else if (this.props.allowedTypes[0] === 'area') {
      labelText = 'Enter Park';
      searchBoxPlaceholderText = 'Enter a park name...';
    } else if (this.props.allowedTypes[0] === 'place') {
      labelText = 'Enter City or State';
      searchBoxPlaceholderText = 'Enter a city or state name...';
    }

    if (this.props.left) {
      labelText += ' to merge or edit';
    } else {
      labelText += ' to merge into';
    }

    return (
      <div className={floatClass}>
        <div className="edit-field">
          <label>{labelText}</label>
          <div className="search-holder">
            <AlgoliaSearchBox
              clearOnSelect
              configs={global.__AT_DATA__.algoliaConfig}
              numResults={10}
              onResultSelect={this.handleSelect}
              placeholder={searchBoxPlaceholderText}
              searchTypes={this.props.allowedTypes}
              testId="location-search-box"
            />
          </div>
        </div>
        {objectInfoBlock}
        <div>
          {statusText}
          {saveButton}
          {deleteButton}
        </div>
      </div>
    );
  }
});

export { LocationInfoHolder };
